"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGeoTreeByID = exports.getGeoTree = void 0;
var _reselect = require("reselect");
var _helpers = require("./helpers");
var EMPTY_ARRAY = [];
var domain = function domain(_) {
  return _.geoTree;
};
var getGeoTree = exports.getGeoTree = (0, _reselect.createSelector)(domain, function (_, _ref) {
  var key = _ref.key;
  return key;
}, function (geoTreeMap, key) {
  return geoTreeMap[key] || EMPTY_ARRAY;
});
var getGeoTreeByID = exports.getGeoTreeByID = function getGeoTreeByID() {
  return (0, _reselect.createSelector)(getGeoTree, function (_, _ref2) {
    var id = _ref2.id;
    return id;
  }, function (tree, id) {
    return (0, _helpers.getTreeByID)(tree, id);
  });
};